import Warning from "@/components/warning";
import router from "@/router";

export function handleError(data, options) {

  let { errcode, msg } = data;
  let { noDialog } = options;
  let approveReason = errcode == 'merchantRefusePass'? data.data.approve_reason : '';
  switch (errcode) {
    case 451:
    case 951:
    case 20005:
    case "tokenNotExists":
    case "tokenInvalid":
      router.push("/login");
      break;
    case "merchantRefusePass":
      if (!noDialog) {
        Warning({
          type: "error",
          message: msg + '\n拒绝原因：\n' + approveReason
        });
      }
      break;
    default:
      if (!noDialog) {
        Warning({
          type: "error",
          message: msg
        });
      }
  }
}
